import React from "react"
import PropTypes from "prop-types"

import DecoratedTextField from "ui-DecoratedTextField"
import { format, parse } from "ui-Number"

export default class Number extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onFieldFlush: PropTypes.func.isRequired,
    currency: PropTypes.string,
    precision: PropTypes.number,
    trim: PropTypes.bool,
    prefix: PropTypes.any, // eslint-disable-line
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  state = {}

  _handleChange = e => {
    if (this.props.onChange) {
      this.props.onChange(e)

      if (e.isDefaultPrevented()) {
        return
      }
    }

    this.setState({ value: e.target.value })
    this.props.onFieldChange(this._parseEvent(e))
  }

  _handleCommit = () => {
    this.props.onFieldFlush(this._parseValue(this.state.value))
  }

  _handleFocus = e => {
    const event = this._parseEvent(e)
    this.setState({ event })
  }

  _parseEvent(e) {
    return this._parseValue(e.target.value)
  }

  _parseValue(value) {
    const parsed = value && parse(value)

    return {
      value: isNaN(parsed) ? undefined : parsed,
      rawValue: value,
    }
  }

  _handleBlur = e => {
    this.setState({ value: undefined })
    this.props.onFieldFlush(this._parseEvent(e))
  }

  _format(value, forEditing = false) {
    if (typeof value !== "number") {
      return ""
    }

    const { trim, currency, prefix } = this.props
    let { precision } = this.props
    if (forEditing) {
      precision = false
    }

    let formatted = format(value, { precision, trim, currency })

    // Currency formatted adds adornments automatically. If we are providing a
    // prefix then strip any of those adornments.
    if (currency && prefix) {
      formatted = formatted.replace(/[^\s0-9.,]/g, "")
    }

    return formatted
  }

  render() {
    const {
      onFieldChange,
      onFieldFlush,
      value,
      precision,
      trim,
      currency,
      ...otherProps
    } = this.props

    return (
      <DecoratedTextField
        {...otherProps}
        value={this.state.value || this._format(value)}
        onBlur={this._handleBlur}
        onFocus={this._handleFocus}
        onChange={this._handleChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/Number.js